import DataService from "../../../../service/DataService";
import MethodService from "../../../../service/MethodService";
import RequestsModel from "../RequestsModel";
export const dataMixins = {
  data() {
    return {
      currentUser: MethodService.getCurrentUser(),
      currentCompany: MethodService.getCompanyInfo(),
      currentProfile: MethodService.getUserProfile(),
      mData: {
        reselectEmployee: false,
        id: null,
        viewMode: "create",
        tableRules: MethodService.copyObject(RequestsModel.tableRules),
        dataForm: MethodService.copyObject(RequestsModel.dataForm),
        validForm: RequestsModel.validForm,
        dataFormRejectRequest: MethodService.copyObject(RequestsModel.dataFormRejectRequest),
        validFormRejectRequest: RequestsModel.validFormRejectRequest,
        dataFormCancelRequest: MethodService.copyObject(RequestsModel.dataFormCancelRequest),
        validFormCancelRequest: RequestsModel.validFormCancelRequest,
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          listType: DataService.listLoaiLyDo,
          listLoaiLyDoNghi: DataService.listLoaiLyDoNghi,
          listPhanLoai: RequestsModel.listPhanLoai,
          listCapDuyet: RequestsModel.listCapDuyet,
          listNhanVien: [],
          listEmployeeWorkExplanation: [],
          listQuanLyTrucTiep: [],
          listDepartment: [],
          listBranch: [],
          listNgayNghi: [],
          listRequestReason: []
        }
      },
      requestEmployeeFilter: {
        department_ids: [],
        branch_ids: []
      },
      isSelectEmployee: true,
      createRequest: true,
      validTimeCreateReq: false,
      listEmployeeApprove: [],
      listHrApprove: [],
      listEmployeeShift: [],
      listEmployeeShiftDetail: [],
      dataTableDate: [],
      remain_allow_dayoff_number_current_year: 0,
      remain_unallow_dayoff_number_current_year: 0,
      remain_allow_dayoff_number_next_year: "",
      remain_unallow_dayoff_number_next_year: "",
      currentYear: new Date().getFullYear(),
      nextYear: new Date().getFullYear() + 1,
      pickerOptionFrom: {
        disabledDate() {
          return false;
        }
      },
      pickerOptionFromTo: {
        disabledDate(time) {
          return (
            time.getTime() > new Date(new Date().getFullYear() + 1, 11, 31).getTime()
          );
        }
      },
      pickerOptionTo: {
        disabledDate(time) {
          return (
            time.getTime() > new Date(new Date().valueOf() - 1000 * 60 * 60 * 24).getTime()
          );
        }
      },
      pickerOptionFromGoOnBussiness: {
        disabledDate() {
          return false;
        }
      },
    };
  },
  computed: {
    filteredRequestEmployees() {
      return this.fn_filterEmployeesByRequestOrg(
        this.mData.dataDefault.listNhanVien || []
      );
    },
    filteredRequestWorkExplanationEmployees() {
      return this.fn_filterEmployeesByRequestOrg(
        this.mData.dataDefault.listEmployeeWorkExplanation || []
      );
    }
  }
};
